import { render, staticRenderFns } from "./booking-sport.input.vue?vue&type=template&id=5c2543ab&"
import script from "./booking-sport.input.vue?vue&type=script&lang=ts&"
export * from "./booking-sport.input.vue?vue&type=script&lang=ts&"
import style0 from "./booking-sport.input.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports